import { render, staticRenderFns } from "./UserMenuItem.vue?vue&type=template&id=22b5d196&scoped=true"
import script from "./UserMenuItem.vue?vue&type=script&lang=js"
export * from "./UserMenuItem.vue?vue&type=script&lang=js"
import style0 from "./UserMenuItem.vue?vue&type=style&index=0&id=22b5d196&prod&lang=scss&scoped=true"
import style1 from "./UserMenuItem.vue?vue&type=style&index=1&id=22b5d196&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b5d196",
  null
  
)

export default component.exports